module.exports = __webpack_public_path__ + "static/StudioPro-Regular-843cbbfe155d9847e4cea29b64f23ff1.eot";